import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from '../common/redux/services/auth';
import { onboardingApi } from '../common/redux/services/onboarding';
import authReducer from '../common/redux/features/authSlice';
import settingsReducer from '../app/home/settings/settings-slice'; // Adjust the path

// Initial setup with static reducers
const staticReducers = {
  auth: authReducer,
  settings: settingsReducer,
  [authApi.reducerPath]: authApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
};

// Reducer injection functionality
export function createReducer(injectedReducers = {}) {
  return combineReducers({
    ...staticReducers,
    ...injectedReducers,
  });
}

// Create the store with empty injected reducers initially
export const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      authApi.middleware,
      onboardingApi.middleware,
    ]),
});

// Set up for dynamic injection
store.injectedReducers = {}; // Track injected reducers
store.injectReducer = (key, reducer) => {
  if (!store.injectedReducers[key]) {
    store.injectedReducers[key] = reducer;
    store.replaceReducer(createReducer(store.injectedReducers));
  }
};

// Type definitions
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Optional for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;
